export const CHART_CONSTANTS = {
	HEIGHT: 400,
	COLORS: {
		PRIMARY_LINE: 'rgba(249, 112, 82, 1)',
		AXIS_LABEL: '#607085'
	},
	LINE: {
		WIDTH: 2,
		MARKER_RADIUS: 4
	},
	LABELS: {
		DISPLAY_INTERVAL: 3,
		ROTATION: 0
	},
	SERIES: {
		NAME: 'Accessibility Score',
		TYPE: 'line' as const
	}
} as const;

export const CHART_TEXT = {
	TITLE: 'Accessibility score over time',
	DESCRIPTION: 'This chart shows the accessibility score trend.',
	NO_DATA_MESSAGE: 'No data available',
	TABLE_COLUMNS: {
		DATE: 'Date',
		SCORE: 'Accessibility Score'
	},
	TOOLTIP: {
		SCORE_LABEL: 'Score:',
		DATE_LABEL: 'Date:'
	}
} as const;
